import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebaseConfig"; // Ensure the path is correct
import "./styles/App.css";

// Import your pages
import SignIn from "./pages/SignIn";
import Home from "./pages/Home";
import Scheduling from "./pages/Scheduling";
import AddItem from "./pages/AddItem";
import BillsCredits from "./pages/BillsCredits";
import Calendar from "./pages/Calendar";
// import ClockIn from "./pages/ClockIn";
import Contractors from "./pages/Contractors";
import CustomerCodes from "./pages/CustomerCodes";
import Maps from "./pages/Maps";
import Notebook from "./pages/Notebook";
import PropertiesClients from "./pages/PropertiesClients";
import Management from "./pages/Management";
import ProposalsJMC from "./pages/ProposalsJMC";
import ProposalsDCS from "./pages/ProposalsDCS";
import SendInvoices from "./pages/SendInvoices";
import Settings from "./pages/Settings";
import Staff from "./pages/Staff";
import Vendors from "./pages/Vendors";
import WorkOrders from "./pages/WorkOrders";
import AdminPortal from "./pages/AdminPortal";
import UserManagement from "./pages/UserManagement";
import ClockTime from "./pages/ClockTime";
import Supplies from "./pages/Supplies";
import FireWatch from "./pages/FireWatch";
import NeedsScheduling from "./pages/NeedsScheduling";
import SentProposals from "./pages/SentProposals";
import LicenseCertificates from "./pages/LicenseCertificates";
import Reconcile from "./pages/Reconcile";
import KondeElectric from "./pages/KondeElectric";
import Projetcs from "./pages/Projects";
import Vehicles from "./pages/Vehicles";
import Spreadsheet from "./pages/Spreadsheet";
import SpreadsheetAdmin from "./pages/SpreadsheetAdmin";
import Eula from "./pages/Eula";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DataBase from "./pages/DataBase";
import JobChecklist from "./pages/JobChecklist";
import TimeOff from "./pages/TimeOff";
import TimeOffAdmin from "./pages/TimeOffAdmin";
import AdminAccess from "./pages/AdminAccess";
import QuoteBuilder from "./pages/QuoteBuilder";
import PaymentsReceived from "./pages/PaymentsReceived";
import RemindersPage from "./pages/RemindersPage";
import SmartBoardList from "./pages/SmartBoardList";
import CompletedJobs from "./pages/CompletedJobs";
import FinancialsDashboard from "./pages/FinancialsDashboard";
import OverheadSettings from "./pages/OverheadSettings";
import JobFinancials from "./pages/JobFinancials";
import DailyLabor from "./pages/DailyLabor";
import DailySpending from "./pages/DailySpending";
import CompletedProposals from "./pages/CompletedProposals";
import ApprovedProposals from "./pages/ApprovedProposals";
import DCSCompletedProposals from "./pages/DCSCompletedProposals";
import DCSApprovedProposals from "./pages/DCSApprovedProposals";
import DCSSentProposals from "./pages/DCSSentProposals";
import Deposits from "./pages/Deposits";
import SupervisorDashboard from "./pages/SupervisorDashboard";
import SubMeter from "./pages/SubMeter";
import PiedmontSubMeter from "./pages/PiedmontSubMeter";
import JobHistory from "./pages/JobHistory";
import InvoicePPD from "./pages/InvoicePPD";
import InvoiceBuilderPPD from "./pages/InvoiceBuilderPPD";
import InvoiceDropdownsAdmin from "./pages/InvoiceDropdownsAdmin";
import ProposalsPPDDropdownsAdmin from "./pages/ProposalsPPDDropdownsAdmin";
import SupervisorPortal from "./pages/SupervisorPortal";
import Reports from "./pages/Reports";
import ApprovedInvoices from "./pages/ApprovedInvoices";
import StaffSettings from "./pages/StaffSettings";
import NotificationRecipients from "./pages/NotificationRecipients";
import Accounting from "./pages/Accounting";
import JobEstimateSpreadsheet from "./pages/JobEstimateSpreadsheet";
import BankStatementEntries from "./pages/BankStatementEntries";
import Expenses from "./pages/Expenses";
import ProfitSharing from "./pages/ProfitSharing";
import CashPlanDashboard from "./pages/CashPlanDashboard";
import AccountingExports from "./pages/AccountingExports";


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Add a loading state

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userId = user.uid;

        try {
          // Fetch user role from Firestore
          const userDocRef = doc(db, "users", userId);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            setUserRole(userDoc.data().role);
            setIsLoggedIn(true);
          } else {
            console.error("User role not found.");
            setIsLoggedIn(false);
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
        }
      } else {
        setIsLoggedIn(false);
        setUserRole(null);
      }
      setIsLoading(false); // Stop loading once Firebase resolves the user
    });

    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setIsLoggedIn(false);
      setUserRole(null);
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  // Define role-based menu items
  const menuItems = {
    Tech: [
   //   { label: "Home", path: "/" },
   
    ],
    Admin: [
     // { label: "Clock In", path: "/ClockIn" },



    //  { label: "Spreadsheet", path: "/Spreadsheet" },
      // { label: "Privacy Policy", path: "/PrivacyPolicy" },



    ],
    Manager: [
     // { label: "Spreadsheet", path: "/Spreadsheet" },


    ],
    KondeElectric: [
      //{ label: "Customer Codes", path: "/CustomerCodes" },

    ],

    Assistant: [


      //{ label: "Spreadsheet", path: "/Spreadsheet" },

    ],
  };

  // Sort menu items for each role alphabetically by label
  Object.keys(menuItems).forEach(role => {
    menuItems[role] = menuItems[role].sort((a, b) =>
      a.label.localeCompare(b.label)
    );
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isLoggedIn) {
    return (
      <Router>
        <SignIn setUserRole={setUserRole} />
      </Router>
    );
  }

  return (
    <Router>
      <header className="header">
        <div className="logo">
          <img src="/logo.png" alt="Priority Pest Defense" />
        </div>
        <div className="app-title">Priority Pest Defense</div>
        <button className="signout-button" onClick={handleSignOut}>Sign Out</button>
      </header>

      <nav className="menu">
        {userRole &&
          menuItems[userRole]?.map((item) => (
            <Link key={item.path} to={item.path}>
              {item.label}
            </Link>
          ))}
      </nav>

      <div className="content">
        <Routes>
          <Route
            path="/"
            element={userRole === "KondeElectric" ? <KondeElectric /> : <Home />}
          />
          <Route path="/JobChecklist/:jobId" element={<JobChecklist />} />
          {userRole === "Tech" && (
            <>
              <Route path="/AddItem" element={<AddItem />} />
              <Route path="/Calendar" element={<Calendar />} />
          {/*    <Route path="/ClockIn" element={<ClockIn />} /> */}
              <Route path="/Maps" element={<Maps />} />
              <Route path="/CustomerCodes" element={<CustomerCodes />} />
              <Route path="/Supplies" element={<Supplies />} />
              <Route path="/FireWatch" element={<FireWatch />} />
              <Route path="/Eula" element={<Eula />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/TimeOff" element={<TimeOff />} />
            </>
          )}
          {userRole === "Admin" && (
            <>
              <Route path="/AdminPortal" element={<AdminPortal />} />
              <Route path="/Scheduling" element={<Scheduling />} />
              <Route path="/AddItem" element={<AddItem />} />
              <Route path="/Calendar" element={<Calendar />} />
           {/*     <Route path="/ClockIn" element={<ClockIn />} /> */}
              <Route path="/ClockTime" element={<ClockTime />} />
              <Route path="/WorkOrders" element={<WorkOrders />} />
              <Route path="/Maps" element={<Maps />} />
              <Route path="/Contractors" element={<Contractors />} />
              <Route path="/CustomerCodes" element={<CustomerCodes />} />
              <Route path="/Notebook" element={<Notebook />} />
              <Route path="/PropertiesClients" element={<PropertiesClients />} />
              <Route path="/ProposalsJMC" element={<ProposalsJMC />} />
              <Route path="/ProposalsDCS" element={<ProposalsDCS />} />
              <Route path="/SendInvoices" element={<SendInvoices />} />
              <Route path="/Staff" element={<Staff />} />
              <Route path="/Vendors" element={<Vendors />} />
              <Route path="/BillsCredits" element={<BillsCredits />} />
              <Route path="/UserManagement" element={<UserManagement />} />
              <Route path="/Supplies" element={<Supplies />} />
              <Route path="/Management" element={<Management />} />
              <Route path="/Settings" element={<Settings />} />
              <Route path="/FireWatch" element={<FireWatch />} />
              <Route path="/NeedsScheduling" element={<NeedsScheduling />} />
              <Route path="/SentProposals" element={<SentProposals />} />
              <Route path="/LicenseCertificates" element={<LicenseCertificates />} />
              <Route path="/Reconcile" element={<Reconcile />} />
              <Route path="/KondeElectric" element={<KondeElectric />} />
              <Route path="/Projects" element={<Projetcs />} />
              <Route path="/Vehicles" element={<Vehicles />} />
              <Route path="/Spreadsheet" element={<Spreadsheet />} />
              <Route path="/SpreadsheetAdmin" element={<SpreadsheetAdmin />} />
              <Route path="/Eula" element={<Eula />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/DataBase" element={<DataBase />} />
              <Route path="/TimeOff" element={<TimeOff />} />
              <Route path="/TimeOffAdmin" element={<TimeOffAdmin />} />
              <Route path="/AdminAccess" element={<AdminAccess />} />
              <Route path="/QuoteBuilder" element={<QuoteBuilder />} />
              <Route path="/PaymentsReceived" element={<PaymentsReceived />} />
              <Route path="/RemindersPage" element={<RemindersPage />} />
              <Route path="/SmartBoardList" element={<SmartBoardList />} />
              <Route path="/Financials" element={<FinancialsDashboard />} />
<Route path="/OverheadSettings" element={<OverheadSettings />} />
<Route path="/JobFinancials/:id" element={<JobFinancials />} />
<Route path="/DailyLabor" element={<DailyLabor />} />
<Route path="/DailySpending" element={<DailySpending />} />
<Route path="/ApprovedProposals" element={<ApprovedProposals />} />
<Route path="/CompletedProposals" element={<CompletedProposals />} />
<Route path="/DCSApprovedProposals" element={<DCSApprovedProposals />} />
<Route path="/DCSCompletedProposals" element={<DCSCompletedProposals />} />
<Route path="/DCSSentProposals" element={<DCSSentProposals />} />
<Route path="/Deposits" element={<Deposits />} />
<Route path="/SupervisorDashboard" element={<SupervisorPortal />} />
<Route path="/SubMeter" element={<SubMeter />} />
<Route path="/PiedmontSubMeter" element={<PiedmontSubMeter />} />
<Route path="/JobHistory" element={<JobHistory />} />
<Route path="/InvoicePPD" element={<InvoicePPD />} />
<Route
  path="/invoice"
  element={<InvoiceBuilderPPD />}
/>
<Route path="/InvoiceDropdownsAdmin" element={<InvoiceDropdownsAdmin />} />
<Route path="/ProposalsPPDDropdownsAdmin" element={<ProposalsPPDDropdownsAdmin />} />
<Route path="/Reports" element={<Reports />} />
<Route path="/ApprovedInvoices" element={<ApprovedInvoices />} />
<Route path="/StaffSettings" element={<StaffSettings />} />
<Route path="/notification-recipients" element={<NotificationRecipients />} />
<Route path="/Accounting" element={<Accounting />} />
<Route path="/JobEstimateSpreadsheet" element={<JobEstimateSpreadsheet />} />
<Route path="/BankStatementEntries" element={<BankStatementEntries />} />
<Route path="/Expenses" element={<Expenses />} />
<Route path="/ProfitSharing" element={<ProfitSharing />} />
<Route path="/CashPlanDashboard" element={<CashPlanDashboard />} />
<Route path="/AccountingExports" element={<AccountingExports />} />

            </>
          )}
          {userRole === "Manager" && (
            <>
              <Route path="/AdminPortal" element={<AdminPortal />} />
              <Route path="/Scheduling" element={<Scheduling />} />
              <Route path="/AddItem" element={<AddItem />} />
              <Route path="/Calendar" element={<Calendar />} />
          {/*      <Route path="/ClockIn" element={<ClockIn />} /> */}
              <Route path="/WorkOrders" element={<WorkOrders />} />
              <Route path="/Maps" element={<Maps />} />
              <Route path="/Contractors" element={<Contractors />} />
              <Route path="/CustomerCodes" element={<CustomerCodes />} />
              <Route path="/Notebook" element={<Notebook />} />
              <Route path="/PropertiesClients" element={<PropertiesClients />} />
              <Route path="/ProposalsJMC" element={<ProposalsJMC />} />
              <Route path="/ProposalsDCS" element={<ProposalsDCS />} />
              <Route path="/SendInvoices" element={<SendInvoices />} />
              <Route path="/Vendors" element={<Vendors />} />
              <Route path="/Supplies" element={<Supplies />} />
              <Route path="/Management" element={<Management />} />
              <Route path="/FireWatch" element={<FireWatch />} />
              <Route path="/NeedsScheduling" element={<NeedsScheduling />} />
              <Route path="/SentProposals" element={<SentProposals />} />
              <Route path="/Projects" element={<Projetcs />} />
              <Route path="/Vehicles" element={<Vehicles />} />
              <Route path="/Spreadsheet" element={<Spreadsheet />} />
              <Route path="/Eula" element={<Eula />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/TimeOff" element={<TimeOff />} />
              <Route path="/RemindersPage" element={<RemindersPage />} />
              <Route path="/ApprovedProposals" element={<ApprovedProposals />} />
<Route path="/CompletedProposals" element={<CompletedProposals />} />
<Route path="/DCSApprovedProposals" element={<DCSApprovedProposals />} />
<Route path="/DCSCompletedProposals" element={<DCSCompletedProposals />} />
<Route path="/DCSSentProposals" element={<DCSSentProposals />} />
<Route path="/SubMeter" element={<SubMeter />} />
<Route path="/PiedmontSubMeter" element={<PiedmontSubMeter />} />
<Route path="/JobHistory" element={<JobHistory />} />
<Route path="/ApprovedInvoices" element={<ApprovedInvoices />} />
<Route path="/JobFinancials/:id" element={<JobFinancials />} />
            </>
          )}
          {userRole === "KondeElectric" && (
            <>
              <Route path="/KondeElectric" element={<KondeElectric />} />
              <Route path="/Maps" element={<Maps />} />
              <Route path="/CustomerCodes" element={<CustomerCodes />} />
              <Route path="/Eula" element={<Eula />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            </>
          )}
          {userRole === "Assistant" && (
            <>
              <Route path="/AdminPortal" element={<AdminPortal />} />
              <Route path="/Scheduling" element={<Scheduling />} />
              <Route path="/AddItem" element={<AddItem />} />
              <Route path="/Calendar" element={<Calendar />} />
           {/*     <Route path="/ClockIn" element={<ClockIn />} /> */}
              <Route path="/ClockTime" element={<ClockTime />} />
              <Route path="/WorkOrders" element={<WorkOrders />} />
              <Route path="/Maps" element={<Maps />} />
              <Route path="/Contractors" element={<Contractors />} />
              <Route path="/CustomerCodes" element={<CustomerCodes />} />
              <Route path="/Notebook" element={<Notebook />} />
              <Route path="/PropertiesClients" element={<PropertiesClients />} />
              <Route path="/ProposalsJMC" element={<ProposalsJMC />} />
              <Route path="/ProposalsDCS" element={<ProposalsDCS />} />
              <Route path="/SendInvoices" element={<SendInvoices />} />
              <Route path="/Vendors" element={<Vendors />} />
              <Route path="/Supplies" element={<Supplies />} />
              <Route path="/Management" element={<Management />} />
              <Route path="/FireWatch" element={<FireWatch />} />
              <Route path="/NeedsScheduling" element={<NeedsScheduling />} />
              <Route path="/SentProposals" element={<SentProposals />} />
              <Route path="/Projects" element={<Projetcs />} />
              <Route path="/Vehicles" element={<Vehicles />} />
              <Route path="/Spreadsheet" element={<Spreadsheet />} />
              <Route path="/Eula" element={<Eula />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/TimeOff" element={<TimeOff />} />
              <Route path="/RemindersPage" element={<RemindersPage />} />
              <Route path="/ApprovedProposals" element={<ApprovedProposals />} />
<Route path="/CompletedProposals" element={<CompletedProposals />} />
<Route path="/DCSApprovedProposals" element={<DCSApprovedProposals />} />
<Route path="/DCSCompletedProposals" element={<DCSCompletedProposals />} />
<Route path="/DCSSentProposals" element={<DCSSentProposals />} />
<Route path="/SubMeter" element={<SubMeter />} />
<Route path="/PiedmontSubMeter" element={<PiedmontSubMeter />} />
<Route path="/JobHistory" element={<JobHistory />} />
<Route path="/ApprovedInvoices" element={<ApprovedInvoices />} />
<Route path="/JobFinancials/:id" element={<JobFinancials />} />
            </>
            )}
             {userRole === "PiedmontBoard" && (
            <>
              <Route path="/PiedmontSubMeter" element={<PiedmontSubMeter />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;